type RemoveCallbackFn = () => void

/**
 * Allows for questions to ask for their data without breaking the
 * separation between components and containers.
 */
class QuestionMediator {

  questionValueCallback: (questionName: string) => any
  forceSaveCallback: () => void

  /**
   * Used in PipelineSection to set a callback for questions to ask for data.
   * The function returned MUST be invoked before calling this method again.
   * @param callback
   */
  setQuestionValueCallback(callback: (questionName: string) => any): RemoveCallbackFn {
    if (this.questionValueCallback) {
      throw new Error('valueCallback has already been set. Unsubscribe before calling this method.')
    }

    this.questionValueCallback = callback

    return () => this.questionValueCallback = null
  }

  /**
   * Used in PipelineSection to set a callback for forcing a save.
   * The function returned MUST be invoked before calling this method again.
   * @param callback
   */
  setForceSaveCallback(callback: () => void): RemoveCallbackFn {
    if (this.forceSaveCallback) {
      throw new Error('forceSaveCallback has already been set. Unsubscribe before calling this method.')
    }

    this.forceSaveCallback = callback

    return () => this.forceSaveCallback = null
  }

  /**
   * Used in QuestionsGroups to get their question's data
   * @param questionName
   */
  getValueForQuestion(questionName: string) {
    if (!this.questionValueCallback) {
      throw new Error('valueCallback must be set before getValueFor() is called')
    }

    if (!questionName) {
      return undefined
    }

    return this.questionValueCallback(questionName)
  }
}

const QuestionsGroupMediator = new QuestionMediator()

export {
  QuestionsGroupMediator
}



// WEBPACK FOOTER //
// ./src/app/components/questions/mediator/index.tsx